export default "__VITE_ASSET__D53KaYNZ__"